export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('a').on('mouseenter', function () {
            //stuff to do on mouseover
            console.log('play');
            var audio = document.getElementById('audio');
            if (audio.duration > 0 && !audio.paused) {
                // console.log('playing');
                audio.currentTime = 0;
                audio.play();
            }else{
                audio.play();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js